import { render } from "./Parametres.vue?vue&type=template&id=ca76dfa4&scoped=true"
import script from "./Parametres.vue?vue&type=script&lang=js"
export * from "./Parametres.vue?vue&type=script&lang=js"

import "./Parametres.vue?vue&type=style&index=0&id=ca76dfa4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca76dfa4"]])

export default __exports__